module.exports = __webpack_public_path__ + "static/media/song-of-the-philomel.bbbd8f11.jpg";